<h2 mat-dialog-title>
  {{ 'ACCOUNT_DETAILS.EXECUTIVE_REPORT_SENDER.TITLE' | translate }}
</h2>
<mat-dialog-content>
  <glxy-select-input
    [label]="'ACCOUNT_DETAILS.EXECUTIVE_REPORT_SENDER.REPORT_DATE' | translate"
    [formControl]="dateSelector"
    [options]="reportDateOptions$ | async"
  ></glxy-select-input>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="sendReport()">
    {{ 'COMMON.ACTION_LABELS.SEND' | translate }}
  </button>
</mat-dialog-actions>
